(function () {
  'use strict';
  var initialized = false;

  function refresh() {
    var band = document.getElementById('syd-season-band');
    if (!band) return;
    var param = band.dataset.seasonParam;
    var url = new URL(window.location.href);
    var active = url.searchParams.getAll(param).flatMap(function (value) { return value.split(','); });
    var labels = [];
    band.querySelectorAll('[data-season-value]').forEach(function (link) {
      var value = link.dataset.seasonValue;
      var selected = value ? active.indexOf(value) !== -1 : active.length === 0;
      if (selected) {
        link.setAttribute('aria-current', 'true');
        if (value) labels.push(link.dataset.seasonLabel);
      } else {
        link.removeAttribute('aria-current');
      }
      var destination = new URL(url);
      var changing = value ? active.length !== 1 || active[0] !== value : active.length > 0;
      Array.from(destination.searchParams.keys()).forEach(function (name) {
        if (name === param ||
            name === 'page' || name === 'section_id' || name === 'sections' ||
            (changing && ['sh_category', 'sh_fit', 'filter.v.option.size', 'sh_size_pair', 'filter.v.price.gte', 'filter.v.price.lte'].includes(name))) {
          destination.searchParams.delete(name);
        }
      });
      destination.hash = '';
      if (value) destination.searchParams.set(param, value);
      link.href = destination.pathname + destination.search;
    });
    band.querySelector('[data-season-current]').textContent = labels.length ? labels.join(' + ') : band.dataset.allLabel;
    var count = document.getElementById('ProductCount');
    if (count) band.querySelector('[data-archive-count]').textContent = count.textContent.trim();

    document.querySelectorAll('#main-collection-filters details.js-filter').forEach(function (details) {
      var seasonInput = Array.from(details.querySelectorAll('input')).some(function (input) { return input.name === param; });
      var availabilityInput = details.querySelector('input[name="filter.v.availability"]');
      details.classList.toggle('syd-facet-hidden', seasonInput || Boolean(availabilityInput && band.dataset.hideAvailability === 'true'));
    });
  }

  function init() {
    if (!document.getElementById('syd-season-band')) return;
    refresh();
    if (initialized) return;
    initialized = true;
    customElements.whenDefined('facet-filters-form').then(function () {
      var form = customElements.get('facet-filters-form');
      if (!window.FacetFiltersForm) window.FacetFiltersForm = form;
      var original = form.renderProductCount;
      form.renderProductCount = function (html) {
        var result = original.call(this, html);
        refresh();
        return result;
      };
    });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('popstate', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
